import { Navigate, Outlet } from "react-router";
import { useRouterSettings } from "src/routerSettings";
import { useAuthTokenContext } from "User/Authentication/context";

export const ProtectedRoute = () => {
  const routerSettings = useRouterSettings();
  const authTokenContext = useAuthTokenContext();

  if (authTokenContext && !authTokenContext.token) {
    return <Navigate to={routerSettings.routeLogin} />;
  }

  return <Outlet />;
};
